import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FwPlugins, { IFrame, usePluginReducer } from 'framework-plugins';
import Helmet from 'react-helmet';
import Assistente from 'Assistente';
import useSignalR from '../../helpers/useSignalR';
import { getStoredSessionItem, setStoredSessionItem } from './storeSession';
import { SESSION_IMU_NUOVO } from './session';

const Imu = ({ ufficio }) => {
  const [imuNuovo, setImuNuovo] = useState(true);
  const [annoSelezionato, setAnnoSelezionato] = useState(null);

  const refreshCalcoliImu = useCallback(() => {
    FwPlugins.postMessageToChilds('REFRESH_CALCOLI_IMU', null);
  }, []);

  usePluginReducer(() => ({
    CAMBIO_ANNO_IMU: (anno) => {
      setAnnoSelezionato(anno);
      setStoredSessionItem(SESSION_IMU_NUOVO, anno > 2020);
      setImuNuovo(anno > 2020);
    },
    ASSISTENTE_APRIPERMALINK: (payload) => {
        Assistente.apriPermalink(payload);
    },
  }), []);

  useEffect(() => {
    if (getStoredSessionItem(SESSION_IMU_NUOVO) !== null) {
      setImuNuovo(getStoredSessionItem(SESSION_IMU_NUOVO) === 'true');
    }
  }, []);

  useSignalR('SegnalibroModificato', refreshCalcoliImu);
  useSignalR('DichiarazioneEliminata', refreshCalcoliImu);
  useSignalR('AnagraficaDichiarazioneModificata', refreshCalcoliImu);

  return (
    <React.Fragment>
      <Helmet title="IMU" />
      {imuNuovo && (
        <IFrame
          src={window.config.urlImu}
          srcParams={annoSelezionato ? {
            ufficio,
            annoRiferimentoImpostato: annoSelezionato,
          } : {
            ufficio,
          }}
        />
      )}
      {!imuNuovo && (
        <IFrame
          src={window.config.urlImu2020}
          srcParams={{ ufficio }}
        />
      )}
    </React.Fragment>
  );
};

const mapStoreToProps = (store) => ({
  ufficio: store.utente.ufficioSelezionato.CodiceUfficio,
});

Imu.propTypes = {
  ufficio: PropTypes.string.isRequired,
};

export default connect(mapStoreToProps)(Imu);
